import sheetUpdateModal from "@/views/menu/sheet/operation/update/sheetUpdateModal.vue";

export default {
    components: {
        sheetUpdateModal
    },
    props: {},
    data () {
        return {
            // 编辑框
            updateCanEdit: true, // 原因：关联字段所关联的数据那的编辑弹出框，现受关联字段可编辑性控制

            showUpdateModal: false,
            isCreate: false,
            dataId: undefined,
            defaultFormData: undefined,

            dshRenderName: undefined
        };
    },
    computed: {
        totalCanEdit () {
            return this.updateCanEdit && (this.finalCanEdit === undefined ? true : this.finalCanEdit);
        },

        dshRender () {
            return this[this.dshRenderName];
        }
    },
    methods: {
        /* ------- 编辑相关 --------- */
        // 点击新增
        clickCreate (operationItem, defaultFormData) {
            this.defaultFormData = defaultFormData;
            this.isCreate = true;
            this.updateCanEdit = true;
            this.dataId = this.$ObjectID().str;
            this.openUpdateModal();
        },

        // 点击行
        clickRow (dataItem, dataIndex) {
            if (this.operationMap.canUpdate) {
                this.clickUpdate(this.operationMap.canUpdate, dataItem, dataIndex);
            } else if (this.operationMap.canShow) {
                this.clickShow(this.operationMap.canShow, dataItem);
            } else {
                this.$Message.error({
                    content: `抱歉，您无 
                    <span style="color: red;">${this.modName}</span> 的 
                    <span style="color: red;">${this.curScreenName}视图</span> 
                    的查看权限`,
                    duration: 10
                });
            }
        },
        // 点击查看
        clickShow (operationItem, dataItem, dataIndex) {
            this.defaultFormData = undefined;
            this.isCreate = false;
            this.updateCanEdit = false;
            this.dataId = dataItem._id;
            this.openUpdateModal();

            this.clickRowAfter && this.clickRowAfter(dataItem);
        },
        // 点击编辑
        clickUpdate (operationItem, dataItem, dataIndex) {
            this.defaultFormData = undefined;
            this.isCreate = false;
            this.updateCanEdit = true;
            this.dataId = dataItem._id;
            this.openUpdateModal();

            this.clickRowAfter && this.clickRowAfter(dataItem);
        },
        // 拖拽后处理方法
        dealDrag (operationItem, dragEvent, toGroupItem, fromGroupItem, updateObj) {
            // add是跨组拖动，update是同组拖动
            if (dragEvent.type === "add") {
                const dataItem = toGroupItem.list[dragEvent.newIndex];
                Object.assign(dataItem, updateObj);

                this.handleDrag(dataItem => {
                    toGroupItem.total++;
                    fromGroupItem.total--;
                }, dataItem);
                // this.handleDrag(undefined, dataItem).then(data => {
                //     toGroupItem.total++;
                //     fromGroupItem.total--;
                // });
            }
            // 暂时不做任何处理
            else if (dragEvent.type === "update") {

            }
        },

        // 打开编辑模态框
        openUpdateModal () {
            this.dshRenderName = "updateModalRender";
            this.showUpdateModal = true;
        },
        // 关闭编辑模态框
        closeUpdateModal () {
            this.dshRenderName = undefined;
            this.showUpdateModal = false;
        },
        // 切换编辑模态框
        toggleUpdateModal (bool) {
            this.showUpdateModal = bool;
        },
        // 编辑模态框渲染函数
        updateModalRender (h, params) {
            return this.showUpdateModal
                ? h("sheet-update-modal", {
                    props: {
                        value: this.showUpdateModal,
                        companyId: this.companyId,
                        appId: this.appId,
                        defaultModObj: this.modObj,
                        canEdit: this.totalCanEdit,
                        isCreate: this.isCreate,
                        dataId: this.dataId,
                        defaultFormData: this.defaultFormData,
                        propsObj: this.propsObj
                    },
                    on: {
                        input: this.toggleUpdateModal,
                        createCb: this.createCb,
                        updateCb: this.updateCb
                    }
                })
                : undefined;
        },

        // 回调 -新增
        createCb (dataItem) {
            if (["panel"].includes(this.tableType)) {
                const groupItem = this.listData.find(groupItem => groupItem._key === dataItem[this.groupField] || groupItem._key === "");
                groupItem.list.splice(0, 0, dataItem);
                groupItem.total++;
            } else {
                this.reset();
            }
        },
        // 回调 -编辑
        updateCb (dataItem) {
            if (["panel"].includes(this.tableType)) {
                // 先删
                this.listData.some(groupItem => {
                    const findIndex = groupItem.list.findIndex(item => item._id === dataItem._id);
                    if (findIndex > -1) {
                        groupItem.list.splice(findIndex, 1);
                        groupItem.total--;
                        return true;
                    } else {
                        return false;
                    }
                });

                // 后增
                this.createCb(dataItem);
            } else {
                this.reset();
            }
        }
    }
};



// WEBPACK FOOTER //
// ./src/mixins/sheet/operation/updateBtnMixin.js